import { ReactNode, useEffect, useRef } from "react";

const modalStack: symbol[] = [];

function DosModal({title, onClose, children}: {title: string, onClose: VoidFunction, children: ReactNode}) {
    const idRef = useRef(Symbol());

    useEffect(() => {
        const id = idRef.current;
        modalStack.push(id);
        return () => {
            const index = modalStack.indexOf(id);
            if (index !== -1) modalStack.splice(index, 1);
        };
    }, []);

    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape" && modalStack[modalStack.length - 1] === idRef.current) {
                onClose();
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [onClose]);

    return (
        <div className="dos-modal-backdrop" onClick={onClose}>
            <div className="dos-modal" role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()}>
                <div className="dos-modal-titlebar">
                    <span className="dos-modal-title">{title}</span>
                    <button className="dos-modal-close" onClick={onClose} aria-label="Close">X</button>
                </div>
                <div className="dos-modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
  }

  export default DosModal;
